<template>
  <div>
    <multi-selection-list
      caption="Agent States"
      :items="selectableStateChoices"
      @add="addAgentState"
      @remove="removeAgentState"
    />
    <div style="margin-top: 10px" class="flex justify-end">
      <input
        class="btn"
        type="button"
        style="margin-right: 5px"
        value="All"
        @click="selectAll"
      />
      <input class="btn" type="button" value="Clear" @click="clear" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      required: true,
      value: Array,
    },
  },

  computed: {
    selectableStateChoices() {
      return this.$constants.AgentStates.map((x) => ({
        name: x.name,
        selected: this.items.includes(x.value),
      }));
    },
  },

  methods: {
    addAgentState(val) {
      var index = this.$constants.AgentStates.findIndex((x) => x.name == val);
      var selected = this.$constants.AgentStates[index];
      this.items.push(selected.value);
      this.$store.getters.agentArgs.addAgentState(selected.value);
      this.$emit("selected", selected.value);
    },

    removeAgentState(val) {
      var index = this.$constants.AgentStates.findIndex((x) => x.name == val);
      var selected = this.$constants.AgentStates[index];
      var toRemove = this.items.indexOf(selected.value);
      this.items.splice(toRemove, 1);
      this.$store.getters.agentArgs.removeAgentState(selected.value);
      this.$emit("removed", selected.value);
    },

    clear() {
      let i = this.items.length;
      while(i--) {
        this.$store.getters.agentArgs.removeAgentState(this.items[i]);
        this.items.splice(i, 1);
        this.$emit("removed", this.items[i]);
      }
    },

    selectAll() {
      var states = this.selectableStateChoices
        .map((x) => x.name)
        .filter((x) => !this.items.includes(x));
      for (let i = 0; i < states.length; i++) this.addAgentState(states[i]);
    },
  },
};
</script>

<style scoped>
.flex {
  display: flex;
}

.justify-end {
  justify-content: flex-end;
}

.btn {
  font-family: "Roboto", sans-serif;
  text-transform: uppercase;
  outline: 0;
  background: #0186c9;
  border: 0;
  padding: 6px;
  color: #ffffff;
  font-size: 14px;
  cursor: pointer;
}

.control-btn {
  border-radius: 6px;
  height: 36px;
  width: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.3em;
  margin-right: 10px;
  position: relative;
  cursor: pointer;
  margin: 10px;
}

.control-btn .tooltiptext {
  visibility: hidden;
  min-width: 200px;
  background-color: #303030;
  color: #fff;
  text-align: center;
  padding: 5px;
  border-radius: 6px;
  font-size: 12pt;
  position: absolute;
  z-index: 1;
  top: 103%;
  left: 0;
}

.control-btn:hover .tooltiptext {
  visibility: visible;
}

.row {
  align-items: center;
}
</style>